import { NotificationState } from './notification.model';

export const INITIAL_NOTIFICATION_STATE: NotificationState = {
  notifications: [],
  unseenCount: 0,
  communicationCount: null,
  needsActionCount: null,
  loading: false,
  error: null,
  notificationsCachedAt: null,
  unseenCountCachedAt: null,
  applyingNotificationIds: [],
};
